import React from "react";
import { Flex } from "rebass";
import { SpinnerSVG } from "../../svg/SpinnerSVG";

export const Spinner: React.FC = () => (
  <Flex
    width="100%"
    height="100%"
    justifyContent="center"
    alignItems="center"
    color="sp-blue"
  >
    <SpinnerSVG fill="currentColor" size={30} />
  </Flex>
);
